// extracted by mini-css-extract-plugin
export default {"container":"StatsReportView__container___u4zeD","noResultsFound":"StatsReportView__noResultsFound___Jz3kW","noResultsFoundText":"StatsReportView__noResultsFoundText___SbkRI"};